import systemConfigJson from "./system.json";

export const SystemConfig = {
  serverDomain: String(systemConfigJson.serverDomain || "")
    .replace(/^https?:\/\//, "")
    .replace(/\/$/, ""),
  paymentEnabled: systemConfigJson.paymentEnabled === true,
  turnstileSiteKey: String(systemConfigJson.turnstileSiteKey || ""),
} as const;

export function getServerDomain(): string {
  return SystemConfig.serverDomain;
}

export function getApiOrigin(): string {
  const domain = getServerDomain();
  return domain ? `https://api.${domain}` : "";
}

export function getApiBase(): string {
  const origin = getApiOrigin();
  return origin ? `${origin}/v1` : "";
}

export function getSiteHost(username: string): string {
  const domain = getServerDomain();
  return domain ? `${username}.${domain}` : username;
}

export function getSiteOrigin(username: string): string {
  const host = getSiteHost(username);
  return host ? `https://${host}` : "";
}

export function getPlatformOrigin(): string {
  const domain = getServerDomain();
  return domain ? `https://${domain}` : "";
}

export function getCookieDomain(): string {
  const domain = getServerDomain();
  return domain ? `.${domain}` : "";
}

export function isAppHost(hostname: string): boolean {
  const domain = getServerDomain();
  if (!domain || !hostname) return false;
  return hostname === domain || hostname.endsWith(`.${domain}`);
}

export const MediaServer = SystemConfig.serverDomain ? `https://media.${SystemConfig.serverDomain}/ipfs` : "";
